const features = [
  {
    icon: 'ri-flashlight-line',
    title: '全网最快更新',
    desc: '7×24小时不间断追踪台北娜娜、莫里秀、玩偶姐姐等热门人物动态，确保你永远比其他人更早知道最新爆料。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '独家内容保障',
    desc: '拥有专业的吃瓜内容团队，独家采访、深度调查、未公开资料，只在51吃瓜app才能看到的独家内容。',
  },
  {
    icon: 'ri-group-line',
    title: '200万+吃瓜社区',
    desc: '活跃的吃瓜群众社区，实时评论互动、话题讨论、投票评选，和百万网友一起吃瓜聊八卦。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1100px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            平台优势
          </h2>
          <p className="text-foreground-500 text-sm md:text-base">
            为什么200万+吃瓜群众选择51吃瓜app
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {features.map((item, i) => (
            <div
              key={i}
              className="bg-background-100 rounded-xl p-6 md:p-7 text-center transition-all duration-300 hover:bg-background-200/70"
            >
              <span className="w-14 h-14 flex items-center justify-center mx-auto mb-4 rounded-2xl bg-primary-100 text-primary-600">
                <i className={`${item.icon} text-2xl`}></i>
              </span>
              <h3 className="font-heading text-lg font-bold text-foreground-900 mb-3">
                {item.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {item.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}